import { render } from "./p-feature-flag.vue?vue&type=template&id=554c4dc2"
import script from "./p-feature-flag.vue?vue&type=script&lang=js"
export * from "./p-feature-flag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__